export default [
  {
    path: "/bZu3dPLkswGWmGO7D7Dt",
    children: [
      {
        path: "UoTV8XOBAbXA",
        name: "fees-new",
        meta: {
          authRequired: true,
          title: "New Fees",
          acc: ["v68"],
        },
        component: () => import("@/views/fees/new-fee.vue"),
      },
      {
        path: "vud7r1tMpUAn",
        name: "fees-update",
        meta: {
          authRequired: true,
          title: "Update Fees",
          acc: ["v16"],
        },
        component: () => import("@/views/fees/update-fee.vue"),
      },
      {
        path: "B47xeHiSQWSp",
        name: "fees-list",
        meta: {
          authRequired: true,
          title: "Fees",
          acc: ["v62"],
        },
        component: () => import("@/views/fees/fees-list.vue"),
      },
      {
        path: "lfskFlVGLcZk",
        name: "fee-view",
        meta: {
          authRequired: true,
          title: "View Fee",
          acc: ["v96"],
        },
        component: () => import("@/views/fees/view.vue"),
      },
    ],
  },
];
